// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-input-wrapper {
  width: 100%;
  border-radius: 8px;
  max-height: 40px;
  min-height: 40px;
  border: 1px solid #e9eaeb;
  transition: box-shadow 0.2s ease;
  overflow: hidden;
  display: flex;
  align-items: center;
}
html.kiosk-touch .payment-input-wrapper, html.touch-ux .payment-input-wrapper {
  max-height: 48px;
  min-height: 48px;
}
html.kiosk-touch .payment-input-wrapper iframe, html.touch-ux .payment-input-wrapper iframe {
  height: 40px;
}
.payment-input-wrapper iframe {
  width: 100%;
  height: 100%;
}
.payment-input-wrapper:focus-within {
  border-color: #54d2ff;
  box-shadow: 0px 0px 0px 2px #cbf0fd;
}
.payment-input-wrapper.focused {
  border-color: #54d2ff;
  box-shadow: 0px 0px 0px 3px #cbf0fd;
}
.payment-input-wrapper.has-error {
  border-color: #d72d2d;
  box-shadow: 0px 0px 0px 2px #f7caca;
}
@media (max-width: 1023px) {
  .payment-input-wrapper {
    max-height: 48px;
    min-height: 48px;
  }
  .payment-input-wrapper iframe {
    height: 40px;
  }
}

.payment-input-type-wrapper {
  width: 100%;
  border-radius: 8px;
  max-height: 40px;
  min-height: 40px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.payment-input-type-wrapper iframe {
  width: 100%;
  height: 100%;
}
@media (max-width: 1023px) {
  .payment-input-type-wrapper {
    max-height: 48px;
    min-height: 48px;
  }
  .payment-input-type-wrapper iframe {
    height: 40px;
  }
}

.payment-button-submit-wrapper {
  width: 100%;
  border-radius: 4px;
  max-height: 48px;
  min-height: 48px;
  max-width: 280px;
  overflow: hidden;
}

html.touch-ux .payment-button-submit-wrapper {
  max-width: 100%;
}

.payroc-form {
  width: 100% !important;
  max-width: 100% !important;
}
.payroc-form form {
  width: 100% !important;
  max-width: 100% !important;
}
.payroc-form iframe {
  width: 100% !important;
  max-width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Payments/payroc/Payroc.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACF;AAGE;EAEE,gBAAA;EACA,gBAAA;AAFJ;AAII;EACE,YAAA;AAFN;AAME;EACE,WAAA;EACA,YAAA;AAJJ;AAOE;EACE,qBAAA;EACA,mCAAA;AALJ;AAQE;EACE,qBAAA;EACA,mCAAA;AANJ;AAQE;EACE,qBAAA;EACA,mCAAA;AANJ;AASE;EA1CF;IA2CI,gBAAA;IACA,gBAAA;EANF;EAQE;IACE,YAAA;EANJ;AACF;;AAUA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAPF;AASE;EACE,WAAA;EACA,YAAA;AAPJ;AAUE;EAdF;IAeI,gBAAA;IACA,gBAAA;EAPF;EASE;IACE,YAAA;EAPJ;AACF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AARF;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,sBAAA;EACA,0BAAA;AARF;AAUE;EACE,sBAAA;EACA,0BAAA;AARJ;AAWE;EACE,sBAAA;EACA,0BAAA;AATJ","sourcesContent":[".payment-input-wrapper {\n  width: 100%;\n  border-radius: 8px;\n  max-height: 40px;\n  min-height: 40px;\n  border: 1px solid #e9eaeb;\n  transition: box-shadow 0.2s ease;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n\n  // The hosted-field iframe carries a 48px min-height input, so a 48px box clips its hit\n  // area the moment anything rounds up. Touch devices get headroom instead of a clamp.\n  html.kiosk-touch &,\n  html.touch-ux & {\n    max-height: 48px;\n    min-height: 48px;\n\n    iframe {\n      height: 40px;\n    }\n  }\n\n  iframe {\n    width: 100%;\n    height: 100%;\n  }\n\n  &:focus-within {\n    border-color: #54d2ff;\n    box-shadow: 0px 0px 0px 2px #cbf0fd;\n  }\n\n  &.focused {\n    border-color: #54d2ff;\n    box-shadow: 0px 0px 0px 3px #cbf0fd;\n  }\n  &.has-error {\n    border-color: #d72d2d;\n    box-shadow: 0px 0px 0px 2px #f7caca;\n  }\n\n  @media (max-width: 1023px) {\n    max-height: 48px;\n    min-height: 48px;\n\n    iframe {\n      height: 40px;\n    }\n  }\n}\n\n.payment-input-type-wrapper {\n  width: 100%;\n  border-radius: 8px;\n  max-height: 40px;\n  min-height: 40px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n\n  iframe {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media (max-width: 1023px) {\n    max-height: 48px;\n    min-height: 48px;\n\n    iframe {\n      height: 40px;\n    }\n  }\n}\n\n.payment-button-submit-wrapper {\n  width: 100%;\n  border-radius: 4px;\n  max-height: 48px;\n  min-height: 48px;\n  max-width: 280px;\n  overflow: hidden;\n}\n\nhtml.touch-ux .payment-button-submit-wrapper {\n  max-width: 100%;\n}\n\n.payroc-form {\n  width: 100% !important;\n  max-width: 100% !important;\n\n  form {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  iframe {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
